import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Title = styled('span')`
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  color: ${theme.palette.text.dark};
`;

export const Subtitle = styled('div')`
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: ${theme.palette.secondary.main};
`;
